import React from 'react';

export default function TitleSetter({ title }) {
  React.useEffect(() => {
    document.title = title || 'Halo Trading Operations';
    return () => {
      document.title = 'Halo Trading Operations'; // Reset title on unmount
    };
  }, [title]);

  return <React.Fragment />;
}
